'use strict';

var _extends = require('../../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var React = require('react');
var Typography = require('../../DataDisplay/Typography/Typography.js');
var withStyles = require('../../Styles/withStyles.js');
var MenuItem = require('../../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  disabled: {
    '&$disabled': {
      opacity: 1
    }
  },
  root: {},
  gutters: {},
  selected: {},
  dense: {}
};
var MenuItemSubheader = React.forwardRef(function (_ref, ref) {
  var _ref$classes = _ref.classes,
      disabled = _ref$classes.disabled,
      restOfClasses = objectWithoutProperties(_ref$classes, ["disabled"]),
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? '' : _ref$value,
      _ref$TypographyProps = _ref.TypographyProps,
      TypographyProps = _ref$TypographyProps === void 0 ? {
    variant: 'h3'
  } : _ref$TypographyProps,
      children = _ref.children,
      _ref$ListItemClasses = _ref.ListItemClasses,
      ListItemClasses = _ref$ListItemClasses === void 0 ? {
    root: disabled
  } : _ref$ListItemClasses,
      props = objectWithoutProperties(_ref, ["classes", "value", "TypographyProps", "children", "ListItemClasses"]);

  return React__default["default"].createElement(MenuItem["default"], _extends["default"]({
    disabled: true,
    value: value,
    ListItemClasses: ListItemClasses,
    classes: restOfClasses,
    ref: ref
  }, props), React__default["default"].createElement(Typography, TypographyProps, children));
});
var MenuItemSubheader$1 = withStyles["default"](styles)(MenuItemSubheader);

module.exports = MenuItemSubheader$1;
